<template>
  <div class="markdown-render markdown-body" v-html="renderedContent"></div>
</template>

<script>
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
})
md.enable(['table', 'strikethrough'])

export default {
  name: 'MarkdownRenderer',
  props: {
    content: { type: String, default: '' }
  },
  computed: {
    renderedContent() {
      if (!this.content) return ''
      // 如果后端已经提供了 content_html，直接使用
      // 如果只有 content_md，前端渲染
      return md.render(this.content)
    }
  }
}
</script>
